// Utility helpers extracted from JWTContext to reduce file size
import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const USER_STORAGE_KEY = "user";

export function saveStoredUser(user) {
  try {
    localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
    if (localStorage.getItem("currentUser"))
      localStorage.removeItem("currentUser");
  } catch {}
}
export function loadStoredUser() {
  try {
    const legacy = localStorage.getItem("currentUser");
    const raw = localStorage.getItem(USER_STORAGE_KEY) || legacy;
    if (legacy && !localStorage.getItem(USER_STORAGE_KEY)) {
      localStorage.setItem(USER_STORAGE_KEY, legacy);
      localStorage.removeItem("currentUser");
    }
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
export function clearStoredUser() {
  try {
    localStorage.removeItem(USER_STORAGE_KEY);
    localStorage.removeItem("currentUser");
  } catch {}
}

export function extractToken(res) {
  const d = res?.data || {};
  const hdrAuth = res?.headers?.authorization || res?.headers?.Authorization;
  const hdrToken =
    hdrAuth && hdrAuth.startsWith("Bearer ") ? hdrAuth.slice(7) : null;
  return (
    d.sessionToken ||
    d.token ||
    d.accessToken ||
    d.access_token ||
    d.jwt ||
    d.jwtToken ||
    d?.data?.token ||
    d?.data?.accessToken ||
    d?.data?.access_token ||
    d?.data?.jwt ||
    d?.data?.jwtToken ||
    hdrToken ||
    null
  );
}
export function extractRefreshToken(res) {
  const d = res?.data || {};
  return (
    d.refreshToken ||
    d.refresh_token ||
    d?.data?.refreshToken ||
    d?.data?.refresh_token ||
    null
  );
}

export function setSession(token, refreshToken) {
  if (token) {
    localStorage.setItem("authToken", token);
    localStorage.setItem("accessToken", token);
    localStorage.setItem("sessionToken", token);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("authToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("sessionToken");
    delete axios.defaults.headers.common.Authorization;
  }
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  } else if (refreshToken === null) {
    localStorage.removeItem("refreshToken");
  }
}

export function decodeAndCheckExpiry(token) {
  try {
    const decoded = jwtDecode(token);
    if (decoded?.exp && decoded.exp * 1000 < Date.now() - 1000) {
      return { expired: true, payload: decoded };
    }
    return { expired: false, payload: decoded };
  } catch {
    return { expired: false, payload: null };
  }
}
